module.exports = __webpack_public_path__ + "static/tubes-294a66143c448005d45fb112925739ca.svg";